<template>
  <div class="meituanHome">
    <div class="container">
      <van-field
        v-model="receiptCode"
        type="number"
        clearable
        center
        :left-icon="require('@/assets/img/meituan/pwd.jpg')"
        placeholder="请输入团购券券码信息"
        class="formInput"
      />
      <van-button
        block
        color="#FAC530"
        loading-text="加载中..."
        :loading="loading"
        class="redeemBtn"
        @click="submitMeds()"
      >
        立即兑换
      </van-button>
      <van-button block class="viewCouponBtn" @click="jumpDetail()">
        查看我的券包
      </van-button>
      <div class="tips">
        特别说明：
        <span style="color: red;"
          >您买的团购券一经兑换，概不退换，请慎重兑换，谨防刷单诈骗！</span
        ><br />
        如有疑问请拨打客服电话400-662-7299（服务时间9:00-21:00）
      </div>
    </div>
  </div>
</template>

<script>
import { meituanVerify } from '@/api/meituan'
export default {
  name: 'meituanIndex',
  data() {
    return {
      receiptCode: undefined,
      loading: false
    }
  },
  created() {},
  methods: {
    async submitMeds() {
      try {
        if (!this.receiptCode) {
          this.$toast.fail('请填写团购券券码信息')
          return
        }
        await this.$dialog.confirm({
          title: '',
          className: 'mtConfirm',
          allowHtml: true,
          message:
            '请确认为<span style="color: #ee0a24">个人真实消费需求后进行兑换</span>，无他人引导或屏幕共享，<span style="color: #ee0a24">一经兑换，概不退换</span>。切不可将卡号、卡密转交给其他人，<span style="color: #ee0a24">谨防诈骗！</span>'
        })
        this.loading = true
        // query参数：mobile=13358200943&openId=123
        const param = { receiptCode: this.receiptCode, ...this.$route.query }
        const { code } = await meituanVerify(param)
        if (code === 0) {
          // sessionStorage.setItem('meituanToken', data)
          this.$router.push({ name: 'meituanDetail', query: { ...param } })
        }
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    async jumpDetail() {
      await this.$dialog.confirm({
        title: '',
        className: 'mtConfirm',
        message:
          '<span style="color: #ee0a24">请勿</span>在与他人<span style="color: #ee0a24">共享屏幕时打开</span>查看卡密信息，请妥善保管信息，<span style="color: #ee0a24">切不可</span>将卡号、卡密<span style="color: #ee0a24">交给其他人</span>，谨防诈骗！'
      })
      this.$router.push({
        name: 'meituanList',
        query: { ...this.$route.query }
      })
    }
    // async jumpDetail() {
    //   await this.$dialog.confirm({
    //     title: '',
    //     message:
    //       '请勿在与他人共享屏幕时打开查看卡密信息，请妥善保管信息，切不可将卡号、卡密交给其他人，谨防诈骗！',
    //     beforeClose: (action, done) => {
    //       if (action === 'confirm') {
    //         // 使用 setTimeout 3秒后执行跳转
    //         setTimeout(() => {
    //           done() // 关闭对话框
    //           this.$router.push({
    //             name: 'meituanList',
    //             query: { ...this.$route.query }
    //           })
    //         }, 3000)
    //       } else {
    //         done()
    //       }
    //     }
    //   })
    // }
  }
}
</script>
<style lang="less" scoped>
.meituanHome {
  min-height: 100vh;
  background: #ffea8e url(../../assets/img/meituan/indexBg.jpg) top center
    no-repeat;
  background-size: 100% auto;
  .container {
    position: fixed;
    bottom: 8%;
    width: 90%;
    left: 5%;
    padding: 49px 23px 75px;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 15px;
    .formInput {
      background: #f5f7fd;
      border-radius: 10px;
      &::after {
        border-bottom: none;
      }
    }
    .redeemBtn {
      color: #000;
      margin: 30px 0 21px;
      border-radius: 10px;
      font-size: 16px;
      color: #000000;
    }
    .viewCouponBtn {
      border-radius: 10px;
      font-size: 16px;
      color: #000000;
    }
    .tips {
      font-size: 12px;
      color: #323233;
      margin: 20px auto 0;
    }
  }
}
</style>
<style lang="less">
.mtConfirm {
  .van-dialog__message {
    font-size: 15px;
    line-height: 24px;
  }
}
</style>
